
import Vue from  'vue'

export default {

    props: {

        title1: { type: String, default: '???' },
        link1: { type: String, default: '#' },

        title2: { type: String, default: '???' },
        link2: { type: String, default: '#' },

        classBack: { type: Object, default: function() {
            return { 'u-color--black': true }
        } },

        classText: { type: Object, default: function() {
            return { 'u-color--white': true }
        } },

        // Optional value object used to transit data from parent to child:
        // <parent> -> <core-drag-area> -> <child>
        data: Object
    },

    /*mounted()
    {
        this.$emit('ready')
    }*/

    methods: {

        scrollTop()
        {
            this.$root.$children[0].scrollTo(0, 0)
        },
    }
}
